import { render, staticRenderFns } from "./AddMenuGroupCatalog.vue?vue&type=template&id=ced19838&scoped=true"
import script from "./AddMenuGroupCatalog.vue?vue&type=script&lang=js"
export * from "./AddMenuGroupCatalog.vue?vue&type=script&lang=js"
import style0 from "./AddMenuGroupCatalog.vue?vue&type=style&index=0&id=ced19838&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced19838",
  null
  
)

export default component.exports